import * as React from 'react';
import {Svg, Rect, Path} from 'react-native-svg';

const HypoArrowIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Rect width={24} height={24} rx={4} fill="#4AA6E1" />
      <Path
        d="M12.75 16.19l2.72-2.72a.75.75 0 111.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 111.06-1.06l2.72 2.72V6.5a.75.75 0 011.5 0v9.69z"
        fill="#fff"
      />
    </Svg>
  );
};

export default HypoArrowIcon;
